<template>
  <div>
    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
      <router-link :to="{name: 'products', params: {product: 'retaining-walls'}}"
                   class="nav-link" active-class="active" data-toggle="pill">
        Retaining Walls
      </router-link>
      <router-link :to="{name: 'products', params: {product: 'free-standing-walls'}}"
                   class="nav-link" active-class="active" data-toggle="pill">
        Free-standing Walls
      </router-link>
      <router-link :to="{name: 'products', params: {product: 'building-wall-panels'}}"
                   class="nav-link" active-class="active" data-toggle="pill">
        Building Wall Panels
      </router-link>
      <router-link :to="{name: 'products', params: {product: 'columns'}}"
                   class="nav-link" active-class="active" data-toggle="pill">
        Columns
      </router-link>
      <router-link :to="{name: 'products', params: {product: 'architectural-elements'}}"
                   class="nav-link" active-class="active" data-toggle="pill">
        Architectural Elements
      </router-link>
      <router-link :to="{name: 'products', params: {product: 'enclosures'}}"
                   class="nav-link" active-class="active" data-toggle="pill">
        Enclosures
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: "LeftNav",
    data() {
      return {}
    }
  }
</script>

<style scoped>
  .nav-pills .nav-link.active {
    background-color: #ed1c24;
  }

  a {
    color: black;
  }
</style>